export const monthOptions = [
  {'key': '1', 'value': 1, 'text': 'Enero'},
  {'key': '2', 'value': 2, 'text': 'Febrero'},
  {'key': '3', 'value': 3, 'text': 'Marzo'},
  {'key': '4', 'value': 4, 'text': 'Abril'},
  {'key': '5', 'value': 5, 'text': 'Mayo'},
  {'key': '6', 'value': 6, 'text': 'Junio'},
  {'key': '7', 'value': 7, 'text': 'Julio'},
  {'key': '8', 'value': 8, 'text': 'Agosto'},
  {'key': '9', 'value': 9, 'text': 'Septiembre'},
  {'key': '10', 'value': 10, 'text': 'Octubre'},
  {'key': '11', 'value': 11, 'text': 'Noviembre'},
  {'key': '12', 'value': 12, 'text': 'Diciembre'},
];

export const yearsOptions = [
  {'key': '1', 'value': 2019, 'text': '2019'},
  {'key': '2', 'value': 2020, 'text': '2020'},
  {'key': '3', 'value': 2021, 'text': '2021'},
  {'key': '4', 'value': 2022, 'text': '2022'},
  {'key': '5', 'value': 2023, 'text': '2023'},
  {'key': '6', 'value': 2024, 'text': '2024'},
  {'key': '7', 'value': 2025, 'text': '2025'},
  {'key': '8', 'value': 2026, 'text': '2026'},
  {'key': '9', 'value': 2027, 'text': '2027'},
  {'key': '10', 'value': 2028, 'text': '2028'},
  {'key': '11', 'value': 2029, 'text': '2029'},
  {'key': '12', 'value': 2030, 'text': '2030'},
];

export const dateFormat = 'YYYY/MM/DD';

export const headerOffset = 2;

export const modelOffset = 1;


export const getReadCondition = ({userLoggedDealerId, rucFilter, yearFilter, monthFilter}) => {
  if (userLoggedDealerId !== rucFilter) {
    return true;
  }
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  if (yearFilter > currentYear) {
    return false;
  } else if (yearFilter === currentYear) {
    if (monthFilter >= currentMonth) {
      return false;
    }
  }

  return true;
};
